import { __decorate } from 'tslib';
import { SpeNPrePixProxy, SpeViewNPixProxy, UiPxPixModule } from '@wlp/ui-px-pix';
import { Injectable, ɵɵdefineInjectable, ɵɵinject, NgModule } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormsModule } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { DocumentValidator, UiBsUtilModule } from '@wlp/ui-bs-util';
import { BehaviorSubject as BehaviorSubject$1 } from 'rxjs/internal/BehaviorSubject';
import { ExtractService } from '@wlp/ui-bs-cashout';
import { SpeJFundsProxy, SpeJCashOutProxy } from '@wlp/ui-px-cashout';
import { map } from 'rxjs/operators';

let ClaimsKeysPixService = class ClaimsKeysPixService {
    constructor(speNPrePixProxy) {
        this.speNPrePixProxy = speNPrePixProxy;
    }
    claimConfirm(confirmRequest, uuidAccountPayment) {
        return this.speNPrePixProxy.confirmClaims(confirmRequest, uuidAccountPayment);
    }
    createConfirm(createRequest) {
        return this.speNPrePixProxy.createClaims(createRequest);
    }
    cancelConfirm(cancelRequest, uuidAccountPayment) {
        return this.speNPrePixProxy.cancelClaims(cancelRequest, uuidAccountPayment);
    }
};
ClaimsKeysPixService.ctorParameters = () => [
    { type: SpeNPrePixProxy }
];
ClaimsKeysPixService = __decorate([
    Injectable()
], ClaimsKeysPixService);

let PortabilityKeysService = class PortabilityKeysService {
    constructor(formBuilder, speNPrePixProxy) {
        this.formBuilder = formBuilder;
        this.speNPrePixProxy = speNPrePixProxy;
        this.behaviorList = new BehaviorSubject(null);
        this.errorMessages = {
            keyTextValue: [
                {
                    type: 'required',
                    message: 'O campo é obrigatório!'
                },
            ],
            keyType: [
                {
                    type: 'required',
                    message: 'O campo é obrigatório!'
                },
            ]
        };
    }
    getFormformPortabilityKey() {
        this.keyForm = this.formBuilder.group({
            keyTextValue: new FormControl('', Validators.required),
            keyType: new FormControl('', Validators.required),
        });
        return this.keyForm;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    getFormBehaviorList() {
        return this.behaviorList;
    }
    setFormBehaviorList(form) {
        this.behaviorList.next(form);
    }
    createClaims() {
        return "";
    }
};
PortabilityKeysService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNPrePixProxy }
];
PortabilityKeysService = __decorate([
    Injectable()
], PortabilityKeysService);

let ConsentUseService = class ConsentUseService {
    constructor() { }
    maskCpf(cpf) {
        if (!cpf)
            return '';
        cpf = String(cpf).replace(/\D/g, '');
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '***.$2.$3-**');
    }
    maskCnpj(cnpj) {
        if (!cnpj)
            return '';
        return String(cnpj)
            .replace(/\D/g, '')
            .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{1})(\d{1})/, '$1.***.***/$4-$5*');
    }
};
ConsentUseService = __decorate([
    Injectable()
], ConsentUseService);

let RegisterKeyService = class RegisterKeyService {
    constructor(formBuilder, speNPrePixProxy) {
        this.formBuilder = formBuilder;
        this.speNPrePixProxy = speNPrePixProxy;
        this.behaviorList = new BehaviorSubject$1(null);
        this.errorMessages = {
            keyType: [
                {
                    type: 'required',
                    message: 'O campo é obrigatório!',
                },
            ],
        };
    }
    getFormRegisterKey() {
        this.keyForm = this.formBuilder.group({
            cpfCnpj: new FormControl(''),
            phone: new FormControl(''),
            email: new FormControl(''),
            keyType: new FormControl('', Validators.required),
        });
        return this.keyForm;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    registerKey(uuidAccountPayment, keyType, key, validationCode) {
        return this.speNPrePixProxy.registerKey(uuidAccountPayment, keyType, key, validationCode);
    }
    deleteKey(uuidAccountPayment, uuidKey) {
        return this.speNPrePixProxy.deleteKey(uuidAccountPayment, uuidKey);
    }
    updateKey(uuidAccountPayment, keyType, key) {
        return this.speNPrePixProxy.updateKey(uuidAccountPayment, keyType, key);
    }
    getAllKey(uuidAccountPayment) {
        return this.speNPrePixProxy.getAllKey(uuidAccountPayment);
    }
    getAllKeyByAccountActive(uuidAccountPayment) {
        return this.speNPrePixProxy.getAllKeyByAccountActive(uuidAccountPayment);
    }
    getFormBehaviorList() {
        return this.behaviorList;
    }
    setFormBehaviorList(form) {
        this.behaviorList.next(form);
    }
};
RegisterKeyService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNPrePixProxy }
];
RegisterKeyService = __decorate([
    Injectable()
], RegisterKeyService);

let AddressingKeyPixService = class AddressingKeyPixService {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.initialBehaviorAddressingKeyPix = {
            docNumber: '',
            phone: '',
            email: '',
            evp: '',
            typeKey: '',
            keyDescription: '',
            paymentValue: 0,
        };
        this.listKeyTypes = [
            { value: 'PHONE', name: 'Celular' },
            { value: 'CPF/CNPJ', name: 'CPF/CNPJ' },
            { value: 'EMAIL', name: 'E-mail' },
            { value: 'EVP', name: 'Chave aleatória' },
        ];
        this.errorMessages = {
            typeKey: [
                { type: 'required', message: 'PIX.ADDRESSING_KEY_PIX.SEARCH_ADDRESSING_KEY.FORM.TYPE_KEY.MESSAGE.REQUIRED' },
            ],
            docNumber: [
                { type: 'cpfNotValid', message: 'PIX.ADDRESSING_KEY_PIX.SEARCH_ADDRESSING_KEY.FORM.CPF.MESSAGE.CPF_NOT_VALID' },
                {
                    type: 'cnpjNotValid',
                    message: 'PIX.ADDRESSING_KEY_PIX.SEARCH_ADDRESSING_KEY.FORM.CNPJ.MESSAGE.CNPJ_NOT_VALID',
                },
            ],
            email: [
                {
                    type: 'minlength',
                    message: 'PIX.ADDRESSING_KEY_PIX.SEARCH_ADDRESSING_KEY.FORM.E_MAIL.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'PIX.ADDRESSING_KEY_PIX.SEARCH_ADDRESSING_KEY.FORM.E_MAIL.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'PIX.ADDRESSING_KEY_PIX.SEARCH_ADDRESSING_KEY.FORM.E_MAIL.MESSAGE.PATTERN' },
            ],
            phone: [
                {
                    type: 'minlength',
                    message: 'PIX.ADDRESSING_KEY_PIX.SEARCH_ADDRESSING_KEY.FORM.PHONE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 10 },
                },
            ],
            evp: [
                {
                    type: 'required',
                    message: 'PIX.ADDRESSING_KEY_PIX.SEARCH_ADDRESSING_KEY.FORM.EVP.MESSAGE.REQUIRED',
                },
            ],
            paymentValue: [
                {
                    type: 'required',
                    message: 'PIX.ADDRESSING_KEY_PIX.PAYMENT_ADDRESSING_KEY.FORM.PAYMENT_VALUE.MESSAGE.REQUIRED',
                },
                {
                    type: 'min',
                    message: 'PIX.ADDRESSING_KEY_PIX.PAYMENT_ADDRESSING_KEY.FORM.PAYMENT_VALUE.MESSAGE.MIN',
                },
                {
                    type: 'max',
                    message: 'PIX.ADDRESSING_KEY_PIX.PAYMENT_ADDRESSING_KEY.FORM.PAYMENT_VALUE.MESSAGE.MAX',
                },
            ],
        };
        this.behaviorAddressingKeyPix = new BehaviorSubject(this.initialBehaviorAddressingKeyPix);
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos no fluxo da Devolução
     */
    setAddressingKeyByFormGroup(form) {
        this.behaviorAddressingKeyPix.next(Object.assign({}, this.behaviorAddressingKeyPix.getValue(), form.getRawValue()));
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos no fluxo da chave de endereçamento
     */
    setAddressingKeyByObject(addressingKeyPix) {
        this.behaviorAddressingKeyPix.next(Object.assign({}, this.behaviorAddressingKeyPix.getValue(), addressingKeyPix));
    }
    getSearchAddressingKeyForm() {
        this.searchAddressingKeyForm = this.formBuilder.group({
            docNumber: new FormControl('', Validators.compose([DocumentValidator.isValidCPFCNPJ])),
            email: new FormControl('', Validators.compose([
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}'),
            ])),
            evp: new FormControl('', Validators.compose([])),
            phone: new FormControl('', Validators.compose([Validators.minLength(11)])),
            typeKey: new FormControl(false, Validators.compose([])),
            keyDescription: new FormControl(false, Validators.compose([])),
            paymentValue: new FormControl('', Validators.compose([Validators.required])),
            dateExecution: new FormControl('', Validators.compose([])),
            showRepeatOptions: new FormControl(false, Validators.compose([])),
            frequency: new FormControl(null, Validators.compose([])),
            occurrences: new FormControl(null, Validators.compose([]))
        });
        return this.searchAddressingKeyForm;
    }
    getPaymentAddressingKeyForm() {
        this.paymentAddressingKeyForm = this.formBuilder.group({
            paymentValue: new FormControl('', Validators.compose([Validators.required])),
            docNumber: new FormControl('', Validators.compose([DocumentValidator.isValidCPFCNPJ])),
            email: new FormControl('', Validators.compose([
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}'),
            ])),
            evp: new FormControl('', Validators.compose([])),
            phone: new FormControl('', Validators.compose([Validators.minLength(13)])),
            typeKey: new FormControl('', Validators.compose([])),
            keyDescription: new FormControl('', Validators.compose([])),
            dateExecution: new FormControl('', Validators.compose([])),
            showRepeatOptions: new FormControl(false, Validators.compose([])),
            frequency: new FormControl(null, Validators.compose([])),
            occurrences: new FormControl(null, Validators.compose([]))
        });
        return this.paymentAddressingKeyForm;
    }
    getListKeyTypes() {
        return this.listKeyTypes;
    }
    unsubscribeBehavior() {
        this.behaviorAddressingKeyPix = new BehaviorSubject(this.initialBehaviorAddressingKeyPix);
    }
    getBehaviorAddressingKeyPix() {
        return this.behaviorAddressingKeyPix;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
};
AddressingKeyPixService.ctorParameters = () => [
    { type: FormBuilder }
];
AddressingKeyPixService = __decorate([
    Injectable()
], AddressingKeyPixService);

let DevolutionService = class DevolutionService {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.initialBehaviorDevolution = {
            devolutionValue: 0,
            devolutionReason: '',
            devolutionRecipient: '',
            transactionId: '',
            devolutionDate: '',
        };
        this.listDevolutionReasons = [
            { code: 'BE08', name: 'Devolvido como resultado de um erro bancário.', value: 'Devolvido como resultado de um erro bancário.' },
            { code: 'FR01', name: 'Devolução por suspeita de fraude.', value: 'Devolução por suspeita de fraude.' },
            { code: 'MD06', name: 'Devolução solicitada pelo cliente final.', value: 'Devolução solicitada pelo cliente final.' },
            { code: 'SL02', name: 'Devolução do valor em dinheiro devido a um erro relacionado ao Pix Saque ou Pix Troco', value: 'Devolução do valor em dinheiro devido a um erro relacionado ao Pix Saque ou Pix Troco' },
        ];
        this.errorMessages = {
            devolutionValue: [
                {
                    type: 'required',
                    message: 'PIX.PIX_DEVOLUTION.FORM.DEVOLUTION_VALUE.MESSAGE.REQUIRED',
                },
                {
                    type: 'max',
                    message: 'PIX.PIX_DEVOLUTION.FORM.DEVOLUTION_VALUE.MESSAGE.MAX',
                },
            ],
            devolutionReason: [
                {
                    type: 'required',
                    message: 'PIX.PIX_DEVOLUTION.FORM.DEVOLUTION_REASON.MESSAGE.REQUIRED',
                },
            ],
            devolutionCode: [
                {
                    type: 'required',
                },
            ],
        };
        this.behaviorDevolution = new BehaviorSubject(this.initialBehaviorDevolution);
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos no fluxo da Devolução
     */
    setDevolutionByFormGroup(devolutionForm) {
        this.behaviorDevolution.next(Object.assign({}, this.behaviorDevolution.getValue(), { devolutionDate: new Date().toISOString() }, devolutionForm.getRawValue()));
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos no fluxo da Devolução
     */
    setDevolutionByObject(devolution) {
        this.behaviorDevolution.next(Object.assign({}, this.behaviorDevolution.getValue(), devolution));
    }
    getFormDevolution() {
        this.devolutionForm = this.formBuilder.group({
            devolutionValue: new FormControl('', Validators.required),
            devolutionReason: new FormControl('', Validators.required),
            devolutionCode: new FormControl('', Validators.required),
        });
        return this.devolutionForm;
    }
    getListDevolutionReasons() {
        return this.listDevolutionReasons;
    }
    unsubscribeBehavior() {
        this.behaviorDevolution = new BehaviorSubject(this.initialBehaviorDevolution);
    }
    getFormMessageError() {
        return this.errorMessages;
    }
};
DevolutionService.ctorParameters = () => [
    { type: FormBuilder }
];
DevolutionService = __decorate([
    Injectable()
], DevolutionService);

let generationQRCodeService = class generationQRCodeService {
    constructor(formBuilder, speNPrePixProxy) {
        this.formBuilder = formBuilder;
        this.speNPrePixProxy = speNPrePixProxy;
        this.initialBehaviorDevolution = {
            devolutionValue: 0,
            devolutionReason: '',
            devolutionRecipient: '',
            transactionId: '',
            devolutionDate: ''
        };
        this.keys = [
            { 'name': 'phone', 'value': '(11)1111-22222' },
            { 'name': 'cpf/cnpj', 'value': '337.133.912-20' },
        ];
        this.errorMessages = {
            generationKey: [
                {
                    type: 'required',
                    message: 'PIX.GENERATION_KEYS.FORM.GENERATION_KEY.MESSAGE.REQUIRED'
                },
            ],
            descriptionKey: [
                {
                    type: 'maxlength',
                    message: 'PIX.GENERATION_KEYS.FORM.DESCRIPTION_KEY.MESSAGE.MAX',
                    param: { maxLength: 100 }
                }
            ],
            valueKey: [
                {
                    type: 'required',
                    message: 'PIX.GENERATION_KEYS.FORM.VALUE_KEY.MESSAGE.REQUIRED',
                }
            ]
        };
    }
    getFormGeneration() {
        this.generationQRCodeForm = this.formBuilder.group({
            generationKey: new FormControl('', Validators.compose([Validators.required])),
            identificationKey: new FormControl('', Validators.compose([])),
            descriptionKey: new FormControl('', Validators.compose([Validators.maxLength(100)])),
            debtorNameKey: new FormControl('', Validators.compose([])),
            debtorDocumentKey: new FormControl('', Validators.compose([])),
            valueKey: new FormControl('', Validators.compose([])),
            noteKey: new FormControl('', Validators.compose([])),
        });
        return this.generationQRCodeForm;
    }
    getListKeys() {
        return this.keys;
    }
    unsubscribeBehavior() {
        this.behaviorDevolution = new BehaviorSubject(this.initialBehaviorDevolution);
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    encodeKey(body) {
        return this.speNPrePixProxy.generateEncodeKey(body);
    }
};
generationQRCodeService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNPrePixProxy }
];
generationQRCodeService = __decorate([
    Injectable()
], generationQRCodeService);

let ResumePaymentService = class ResumePaymentService {
    constructor(formBuilder, extractService) {
        this.formBuilder = formBuilder;
        this.extractService = extractService;
        this.errorMessages = {
            paymentValue: [
                {
                    type: 'required',
                    message: 'O campo é obrigatório!',
                },
            ],
        };
    }
    getFormResumePayment() {
        this.resumePaymentForm = this.formBuilder.group({
            paymentDescription: new FormControl(''),
            paymentValue: new FormControl('', Validators.required),
        });
        return this.resumePaymentForm;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    getReceipt(transactionId) {
        this.extractService.getTransaction(transactionId).subscribe((dataExtractTransaction) => {
            return dataExtractTransaction;
        }, (err) => {
            console.error('Failed to load data', err);
        });
    }
};
ResumePaymentService.ctorParameters = () => [
    { type: FormBuilder },
    { type: ExtractService }
];
ResumePaymentService = __decorate([
    Injectable()
], ResumePaymentService);

class ExtractDigitalAccountResponsePix {
}

let StatementPixService = class StatementPixService {
    constructor(speJFundsProxy) {
        this.speJFundsProxy = speJFundsProxy;
    }
    getExtractPix(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        return this.speJFundsProxy.getCheckStatementPIX(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd)
            .pipe(map(res => this.prepareExtract(res)));
    }
    getLatestTransactionPix(uuidWhilabel, uuidAccountPayment, quantity, typeOrigin) {
        return this.speJFundsProxy.getLatestTransactionPix(uuidWhilabel, uuidAccountPayment, quantity, typeOrigin)
            .pipe(map(res => this.prepareExtract(res)));
    }
    valueDisplayCreditOrDebit(extractDigitalAccount) {
        return !!extractDigitalAccount.credit ? extractDigitalAccount.credit : extractDigitalAccount.debit;
    }
    showIsBalance(typeStatement) {
        return Number(typeStatement) === 0;
    }
    showIsCreditOrDebit(typeStatement) {
        return Number(typeStatement) > 0;
    }
    isCredit(typeStatement) {
        return Number(typeStatement) === 1;
    }
    prepareExtract(listDataStatement) {
        let listExtract = [];
        listDataStatement
            .forEach(data => listExtract.push(this.mountExtractDigital(data)));
        return listExtract;
    }
    mountExtractDigital(dataStatementResponse) {
        const extractDigitalAccount = new ExtractDigitalAccountResponsePix();
        extractDigitalAccount.uuid = dataStatementResponse.uuid;
        extractDigitalAccount.transactionId = dataStatementResponse.transactionId;
        extractDigitalAccount.category = 'Outros';
        extractDigitalAccount.description = dataStatementResponse.description;
        extractDigitalAccount.icon = 'grid-outline';
        extractDigitalAccount.typeStatement = dataStatementResponse.typeStatement;
        extractDigitalAccount.balance = dataStatementResponse.balance;
        extractDigitalAccount.credit = dataStatementResponse.credit;
        extractDigitalAccount.debit = dataStatementResponse.debit;
        extractDigitalAccount.dateRegister = dataStatementResponse.dateRegister;
        extractDigitalAccount.operationDescription = dataStatementResponse.operationDescription;
        return extractDigitalAccount;
    }
};
StatementPixService.ctorParameters = () => [
    { type: SpeJFundsProxy }
];
StatementPixService = __decorate([
    Injectable()
], StatementPixService);

let ValidationCodeService = class ValidationCodeService {
    constructor(formBuilder, speNPrePixProxy) {
        this.formBuilder = formBuilder;
        this.speNPrePixProxy = speNPrePixProxy;
        this.behaviorList = new BehaviorSubject(null);
        this.errorFormMessages = {
            codeNumberOne: [
                { type: 'required', message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 1 },
                },
            ],
            codeNumberTwo: [
                { type: 'required', message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 1 },
                },
            ],
            codeNumberThree: [
                { type: 'required', message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 1 },
                },
            ],
            codeNumberFour: [
                { type: 'required', message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 1 },
                },
            ],
            codeNumberFive: [
                { type: 'required', message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 1 },
                },
            ],
        };
    }
    getForm() {
        this.formSendCode = this.formBuilder.group({
            codeNumberOne: new FormControl('', Validators.compose([Validators.required])),
            codeNumberTwo: new FormControl('', Validators.compose([Validators.required])),
            codeNumberThree: new FormControl('', Validators.compose([Validators.required])),
            codeNumberFour: new FormControl('', Validators.compose([Validators.required])),
            codeNumberFive: new FormControl('', Validators.compose([Validators.required])),
        });
        return this.formSendCode;
    }
    getErrorFormMessage() {
        return this.errorFormMessages;
    }
    createCode(bodyRequest) {
        return this.speNPrePixProxy.createCodeClaimValidation(bodyRequest);
    }
    validationCode(bodyRequest) {
        return this.speNPrePixProxy.validationClaimCode(bodyRequest);
    }
    prepareRequest(uuidWhiteLabel, uuidAccountPayment, keyType, key, code) {
        let body = {
            uuidWhiteLabel,
            uuidAccountPayment,
            keyType,
            key,
            code,
        };
        return body;
    }
};
ValidationCodeService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNPrePixProxy }
];
ValidationCodeService = __decorate([
    Injectable()
], ValidationCodeService);

let PaymentPixService = class PaymentPixService {
    constructor(speJCashOutProxy, speViewNPixProxy) {
        this.speJCashOutProxy = speJCashOutProxy;
        this.speViewNPixProxy = speViewNPixProxy;
    }
    decodePixQrCode(emv) {
        return this.speViewNPixProxy.decodePixQrCode(emv);
    }
    decodePixKey(key, keyType) {
        return this.speViewNPixProxy.decodePixKey(key, keyType);
    }
    pixTransaction(data) {
        return this.speJCashOutProxy.pixTransaction(data);
    }
    pixCheckReturnAllowed(transactionId, returnValue) {
        return this.speJCashOutProxy.pixCheckReturnAllowed(transactionId, returnValue);
    }
};
PaymentPixService.ctorParameters = () => [
    { type: SpeJCashOutProxy },
    { type: SpeViewNPixProxy }
];
PaymentPixService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PaymentPixService_Factory() { return new PaymentPixService(ɵɵinject(SpeJCashOutProxy), ɵɵinject(SpeViewNPixProxy)); }, token: PaymentPixService, providedIn: "root" });
PaymentPixService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], PaymentPixService);

let ManualTransferService = class ManualTransferService {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.initialBehaviorManualTransfer = {
            institution: '',
            agency: '',
            account: '',
            typeAccount: '',
            document: '',
            name: '',
            paymentValue: 0,
            description: '',
        };
        this.errorMessages = {
            institution: [{ type: 'required', message: 'PIX.MANUAL_TRANSFER.FORM.INSTITUTION.MESSAGE.REQUIRED' }],
            agency: [{ type: 'required', message: 'PIX.MANUAL_TRANSFER.FORM.AGENCY.MESSAGE.REQUIRED' }],
            name: [{ type: 'required', message: 'PIX.MANUAL_TRANSFER.FORM.NAME.MESSAGE.REQUIRED' }],
            account: [{ type: 'required', message: 'PIX.MANUAL_TRANSFER.FORM.ACCOUNT.MESSAGE.REQUIRED' }],
            typeAccount: [{ type: 'required', message: 'PIX.MANUAL_TRANSFER.FORM.TYPEACCOUNT.MESSAGE.REQUIRED' }],
            document: [
                { type: 'required', message: 'PIX.MANUAL_TRANSFER.FORM.DOCUMENT.MESSAGE.REQUIRED' },
                { type: 'cpfNotValid', message: 'PIX.MANUAL_TRANSFER.FORM.CPF.MESSAGE.CPF_NOT_VALID' },
                {
                    type: 'cnpjNotValid',
                    message: 'PIX.MANUAL_TRANSFER.FORM.CNPJ.MESSAGE.CNPJ_NOT_VALID',
                },
            ],
            paymentValue: [
                {
                    type: 'required',
                    message: 'PIX.MANUAL_TRANSFER.FORM.PAYMENT_VALUE.MESSAGE.REQUIRED',
                },
                {
                    type: 'min',
                    message: 'PIX.MANUAL_TRANSFER.FORM.PAYMENT_VALUE.MESSAGE.MIN',
                },
                {
                    type: 'max',
                    message: 'PIX.MANUAL_TRANSFER.FORM.PAYMENT_VALUE.MESSAGE.MAX',
                },
            ],
        };
        this.behaviorManualTransfer = new BehaviorSubject(this.initialBehaviorManualTransfer);
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos no fluxo da Devolução
     */
    setManualTransferByFormGroup(form) {
        this.behaviorManualTransfer.next(Object.assign({}, this.behaviorManualTransfer.getValue(), form.getRawValue()));
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos no fluxo da chave de endereçamento
     */
    setManualTransferByObject(manualTransfer) {
        this.behaviorManualTransfer.next(Object.assign({}, this.behaviorManualTransfer.getValue(), manualTransfer));
    }
    getManualTransferForm() {
        this.manualTransferForm = this.formBuilder.group({
            document: new FormControl('', Validators.compose([DocumentValidator.isValidCPFCNPJ, Validators.required])),
            paymentValue: new FormControl('', Validators.compose([Validators.required])),
            institution: new FormControl('', Validators.compose([Validators.required])),
            agency: new FormControl('', Validators.compose([Validators.required])),
            account: new FormControl('', Validators.compose([Validators.required])),
            typeAccount: new FormControl('', Validators.compose([Validators.required])),
            description: new FormControl('', Validators.compose([])),
            name: new FormControl('', Validators.compose([Validators.required])),
        });
        return this.manualTransferForm;
    }
    unsubscribeBehavior() {
        this.behaviorManualTransfer = new BehaviorSubject(this.initialBehaviorManualTransfer);
    }
    getBehaviorManualTransfer() {
        return this.behaviorManualTransfer;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
};
ManualTransferService.ctorParameters = () => [
    { type: FormBuilder }
];
ManualTransferService = __decorate([
    Injectable()
], ManualTransferService);

let UiBsPixModule = class UiBsPixModule {
};
UiBsPixModule = __decorate([
    NgModule({
        declarations: [],
        providers: [
            DevolutionService,
            ConsentUseService,
            AddressingKeyPixService,
            generationQRCodeService,
            RegisterKeyService,
            AddressingKeyPixService,
            ResumePaymentService,
            StatementPixService,
            PortabilityKeysService,
            ValidationCodeService,
            PaymentPixService,
            ClaimsKeysPixService,
            ManualTransferService,
        ],
        imports: [CommonModule, FormsModule, IonicModule, UiBsUtilModule, UiPxPixModule],
        exports: [RxReactiveFormsModule],
    })
], UiBsPixModule);

let QrCodeService = class QrCodeService {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.initialBehaviorQrCode = {
            emv: '',
            paymentValue: 0,
            description: '',
        };
        this.errorMessages = {
            emv: [{ type: 'required', message: 'PIX.QR_CODE.COPY_PASTE.FORM.EMV.MESSAGE.REQUIRED' }],
            paymentValue: [
                {
                    type: 'required',
                    message: 'PIX.QR_CODE.COPY_PASTE.FORM.PAYMENT_VALUE.MESSAGE.REQUIRED',
                },
                {
                    type: 'min',
                    message: 'PIX.QR_CODE.COPY_PASTE.FORM.PAYMENT_VALUE.MESSAGE.MIN',
                },
                {
                    type: 'max',
                    message: 'PIX.QR_CODE.COPY_PASTE.FORM.PAYMENT_VALUE.MESSAGE.MAX',
                },
            ],
        };
        this.behaviorQrCode = new BehaviorSubject(this.initialBehaviorQrCode);
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos
     */
    setQrCodeByFormGroup(form) {
        this.behaviorQrCode.next(Object.assign({}, this.behaviorQrCode.getValue(), form.getRawValue()));
    }
    /**
     * @description Método registra o objeto com os dados já preenchidos
     */
    setQrCodeByObject(qrCode) {
        this.behaviorQrCode.next(Object.assign({}, this.behaviorQrCode.getValue(), qrCode));
    }
    getQrCodeForm() {
        this.qrCodeForm = this.formBuilder.group({
            emv: new FormControl('', Validators.compose([Validators.required])),
            paymentValue: new FormControl('', Validators.compose([Validators.required])),
            description: new FormControl('', Validators.compose([])),
        });
        return this.qrCodeForm;
    }
    unsubscribeBehavior() {
        this.behaviorQrCode = new BehaviorSubject(this.initialBehaviorQrCode);
    }
    getBehaviorQrCode() {
        return this.behaviorQrCode;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
};
QrCodeService.ctorParameters = () => [
    { type: FormBuilder }
];
QrCodeService = __decorate([
    Injectable()
], QrCodeService);

class ClaimKeyCreatePix {
}

class ClaimsPixDictConfirmCancelRequest {
}

var TypeKeyEnum;
(function (TypeKeyEnum) {
    TypeKeyEnum["CPF"] = "CPF";
    TypeKeyEnum["CNPJ"] = "CNPJ";
    TypeKeyEnum["PHONE"] = "PHONE";
    TypeKeyEnum["EMAIL"] = "EMAIL";
    TypeKeyEnum["EVP"] = "EVP";
})(TypeKeyEnum || (TypeKeyEnum = {}));

/*
 * Public API Surface of ui-bs-pix
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddressingKeyPixService, ClaimKeyCreatePix, ClaimsKeysPixService, ClaimsPixDictConfirmCancelRequest, ConsentUseService, DevolutionService, ExtractDigitalAccountResponsePix, ManualTransferService, PaymentPixService, PortabilityKeysService, QrCodeService, RegisterKeyService, ResumePaymentService, StatementPixService, TypeKeyEnum, UiBsPixModule, ValidationCodeService, generationQRCodeService };
//# sourceMappingURL=wlp-ui-bs-pix.js.map
